import React, { useEffect, useState } from 'react'
import { Add_FoodMeal_Api, Delete_FoodMeal_Api, GetAll_FoodMeal_Api } from '../../API/FoodMealApi';
import { Button, Col, Modal, Row } from 'antd';
import {
    CloseOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { FoodCombo } from '../Food/FoodCombo';
export const FoodMealSectionComponent = ({
    setLoading,
    showMessage,
    foodListPeriodId,
    dayId,
    foodSectionId,
    foodSectionTitle,
}) => {
    // =================================================================
    const [foodMeals, setFoodMeals] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [version, setVersion] = useState(0);
    const [foodId, setFoodId] = useState(0);
    // =================================================================
    useEffect(() => {
        loadData();
    }, [version]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_FoodMeal_Api({
                "foodListPeriodId": foodListPeriodId,
                "dayOfWeek": dayId,
                "foodSection": foodSectionId,
            });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setFoodMeals(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const deleteFromList = async (id) => {
        setLoading(true);
        try {
            const data = await Delete_FoodMeal_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                setVersion(version + 1);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const showModal = () => {
        setOpenModal(true);
    };
    const handleOk = async () => {

        setOpenModal(false);
        if (foodId == 0)
            return;

        setLoading(true);
        try {
            const data = await Add_FoodMeal_Api({
                "id": 0,
                "foodListPeriodId": foodListPeriodId,
                "dayOfWeek": dayId,
                "foodSection": foodSectionId,
                "foodId": foodId
            });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                setVersion(version + 1);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    const handleCancel = () => {
        setOpenModal(false);
    };
    // =================================================================

    return (
        <div  >
            <div style={{ textAlign: 'center', borderBottom: '2px solid #cdcdcd', paddingBottom: '10px', fontWeight: 'bold' }}>
                {foodSectionTitle}

                <Button
                    style={{ padding: '5px', height: '20px', marginRight: '10px' }}
                    onClick={showModal}
                >
                    <PlusOutlined style={{ fontSize: '10px' }} />
                </Button>


                <Modal
                    open={openModal}
                    title="اضافه کردن غذا"
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>

                            <CancelBtn />
                            <OkBtn />
                        </>
                    )}
                >
                    <FoodCombo
                        setLoading={setLoading}
                        showMessage={showMessage}
                        onChange={(id) => {setFoodId(id); }}
                    />
                </Modal>


            </div>
            {
                foodMeals?.map((foodMeal) =>
                    <>
                        <Row style={{ border: '1px solid #cdcdcd', margin: '5px', backgroundColor: 'rgb(249 247 247)', borderRadius: '20px' }} key={foodMeal.id}>

                            <Col span={21} style={{ textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }}>
                                {foodMeal.foodTitle}
                            </Col >
                            <Col span={3} >
                                <Button
                                    className='btn-danger'
                                    style={{ padding: '5px', height: '20px', position: 'absolute', top: '8px', left: '5px' }}
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف اطمینان دارید؟',
                                            onOk: () => { deleteFromList(foodMeal.id); setVersion(version + 1) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <CloseOutlined style={{ fontSize: '10px' }} />
                                </Button>
                            </Col>
                        </Row>
                    </>
                )
            }

        </div>
    )
}

